import { Route } from '@angular/router';
import { TenderAnalyticsSettingsComponent } from '../../../../../pages/tender-analytics-settings/tender-analytics-settings.component';
import { AuthenticatedUserGuard } from '../../../../../../auth/routing/guards';
import {PaymentTypesResolver} from '../../../../../../common/routing/resolvers';
import {
    costOfCapitalRoute,
    paymentTermsRoute,
    conversionFactorsRoute,
    inputCurrentContractRoute,
    tenderCurrentContractRoute
} from './children';

export const analyticsSettingsRoute: Route = {
    path: 'analytics-settings',
    component: TenderAnalyticsSettingsComponent,
    canActivate: [AuthenticatedUserGuard],
    resolve: {
        paymentTypesCollection: PaymentTypesResolver,
    },
    children: [
        {
            path: '',
            redirectTo: 'cost-of-capital',
            pathMatch: 'prefix'
        },
        costOfCapitalRoute,
        paymentTermsRoute,
        conversionFactorsRoute,
        inputCurrentContractRoute,
        tenderCurrentContractRoute,
    ]
};
